var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168456",
    transform: "translate(-6086.345 -6237.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85117",
    d: "M6100,6246.5h-6.7c-0.6,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h6.7c0.6,0,1.2-0.5,1.2-1.2 S6100.6,6246.5,6100,6246.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85118",
    d: "M6110,6259.5l-5.4-5.4c3.3-4.1,2.9-10-0.8-13.7c-4-4-10.5-4-14.5,0c-4,4-4,10.5,0,14.5 c3.7,3.7,9.6,4,13.7,0.8l5.4,5.4c0.2,0.2,0.5,0.3,0.8,0.3l0,0c0.3,0,0.6-0.1,0.8-0.3C6110.5,6260.6,6110.5,6259.9,6110,6259.5  M6096.6,6255.6c-4.4,0-8-3.5-8-7.9c0-4.4,3.5-8,7.9-8c4.4,0,8,3.5,8,7.9c0,0,0,0,0,0C6104.6,6252.1,6101,6255.6,6096.6,6255.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessDetails);
export default __webpack_public_path__ + "static/media/less_details.5007292a792d4ec20411a555bc2a4d15.svg";
export { ForwardRef as ReactComponent };